import React from 'react'
import { Card, Typography, Layout } from 'antd'
import { useNavigate, useLocation } from 'react-router-dom'
import Header from '../components/Header'

const { Text, Title } = Typography
const { Content } = Layout

const Unauthorized = () => {
  const navigate = useNavigate()
  const location = useLocation()
  
  // Get error details from query params or state
  const params = new URLSearchParams(location.search)
  const message = params.get('message') || location.state?.message || 'You do not have permission to access this resource.'

  const handleReLogin = () => {
    localStorage.removeItem('user')
    localStorage.removeItem('access_token')
    navigate('/login')
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header hideUserSection={true} />
      <Content
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#f5f5f5',
          padding: '20px',
        }}
      >
      <Card
        style={{
          maxWidth: 500,
          width: '100%',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          borderRadius: '8px',
          textAlign: 'center',
          padding: '20px',
        }}
      >
        <Title level={3} style={{ color: '#ff4d4f', marginBottom: '16px' }}>
          Access Denied
        </Title>
        
        <Text style={{ fontSize: '16px', display: 'block', marginBottom: '20px' }}>
          {message}
        </Text>
        
        <Text
          onClick={handleReLogin}
          style={{
            color: '#1890ff',
            cursor: 'pointer',
            textDecoration: 'none',
            fontSize: '14px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.textDecoration = 'underline'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.textDecoration = 'none'
          }}
        >
          Re-login
        </Text>
      </Card>
      </Content>
    </Layout>
  )
}

export default Unauthorized
